import { useEffect } from "react";
import useInactivity from "../hooks/useInactivity";
import { Result } from 'antd';

export const CourseComplete = ({ lesson, course }) => {
    const { isInactive, isTabInactive } = useInactivity();

    useEffect(() => {
        if (isInactive || isTabInactive) {
            console.log("User is inactive");
        }
    }, [isInactive, isTabInactive]);
    console.log("course", course);
    return (
        <div>
            {/* <h2>You have successfully completed "{course.attributes.course.data.attributes.Title}"</h2> */}
            <Result status="success"
                title={`Congratulations on Completing the "${course.attributes.course.data.attributes.Title}" Course!`}
                subTitle="Thank you for dedicating your time to enhancing your safety skills on the road." />
        </div>
    );
};
